import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormArray } from '@angular/forms';
import { Shop } from '@services/shops/shop.model';
import {
  GeoRules,
  GeoFenceMethodConfig,
} from '@app/pages/checkout-app/checkout-layout/main/components/extensions/components/extension-components/date-picker/components/date-picker-geo-rules/configs';
import { RulesDynamicFormService } from '@app/sharedModule/components/rules-dynamic-form/rules-dynamic-form.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'date-picker-geo-rules',
  templateUrl: './date-picker-geo-rules.component.html',
  styleUrls: ['./date-picker-geo-rules.component.scss'],
  standalone: false,
})
export class DatePickerGeoRulesComponent implements OnInit, OnDestroy {
  @Input() formGroup: UntypedFormGroup;
  @Input() shop: Shop;
  readonly formArrayFieldName = 'geoRules';
  destroy$ = new Subject<void>();
  geoFenceMethodsConfig = [...GeoFenceMethodConfig];
  geoRules = [...GeoRules];
  entities: string[];

  constructor(private rulesDynamicFormService: RulesDynamicFormService) {}
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.entities = this.geoRules?.map((r) => r.entity);
  }

  onGeoFenceMethodChange(event): void {
    if (event !== 'geoRules') {
      this.formGroup.setControl(this.formArrayFieldName, new UntypedFormArray([]));
    } else {
      this.formGroup
        .get(this.formArrayFieldName)
        ?.valueChanges.pipe(takeUntil(this.destroy$))
        .subscribe(() => {
          this.formGroup.get('geoFenceMethod')?.updateValueAndValidity();
        });
    }
  }
}
